import styled from "@emotion/styled";

export const ErrorMessage = styled.div<{ pt?: number }>`
  font-size: 12px;
  font-weight: 400;
  color: ${p => p.theme.palette.redDark};
  padding-top: ${p => (p.pt !== undefined ? `${p.pt}px` : `5px`)};
`;
